import React from 'react'
import View from './view'

const BookingSingle = ({ ...props }) => {
    return <View {...props} />
}

export default BookingSingle
